// extracted by mini-css-extract-plugin
export var section_header = "SectionHeader-module--section_header--1BXzt";
export var section_background = "SectionHeader-module--section_background--ajweK";
export var section_title = "SectionHeader-module--section_title--FzI5a";